import { render, staticRenderFns } from "./PurchaseOrderTerms.vue?vue&type=template&id=f21cfd94&lang=pug"
var script = {}
import style0 from "./PurchaseOrderTerms.vue?vue&type=style&index=0&id=f21cfd94&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports